import {
  IconButton,
  IconEdit,
  InputLabel,
  PrimaryButton,
  SecondaryButton,
  Select,
  Space,
  WithTooltip,
} from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from '../messages'

interface IHeaderActionsProps {
  showEdit: boolean
  showRevise: boolean
  showApprovalActions: boolean
  nextApproverOptions: { label: string; value: number }[]
  selectedNextApproverOption: { label: string; value: number } | null
  onSelectedNextApproverIdChange: (id: Nullable<number>) => void
  hasNextApproverChoices: boolean
  isFinalApproval: boolean
  isApproving: boolean
  isDenying: boolean
  onEdit: () => void
  onRevise: () => void
  onApprove: () => void
  onDeny: () => void
}

export const HeaderActions = ({
  showEdit,
  showRevise,
  showApprovalActions,
  nextApproverOptions,
  selectedNextApproverOption,
  onSelectedNextApproverIdChange,
  hasNextApproverChoices,
  isFinalApproval,
  isApproving,
  isDenying,
  onEdit,
  onRevise,
  onApprove,
  onDeny,
}: IHeaderActionsProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space direction='vertical' align='end'>
      <Space direction='horizontal' align='center'>
        {showEdit && (
          <WithTooltip title={intl.formatMessage(messages.editActionButton)}>
            <IconButton
              aria-label={intl.formatMessage(messages.editActionButton)}
              iconComponent={<IconEdit />}
              onClick={onEdit}
            >
              {intl.formatMessage(messages.editActionButton)}
            </IconButton>
          </WithTooltip>
        )}
        {showRevise && (
          <SecondaryButton onClick={onRevise}>
            {intl.formatMessage(messages.reviseActionButton)}
          </SecondaryButton>
        )}
        {showApprovalActions ? (
          <SecondaryButton onClick={onDeny} disabled={isApproving || isDenying}>
            {intl.formatMessage(messages.denyButton)}
          </SecondaryButton>
        ) : null}
        {showApprovalActions ? (
          <PrimaryButton
            onClick={onApprove}
            disabled={isApproving || isDenying}
          >
            {intl.formatMessage(messages.approveButton)}
          </PrimaryButton>
        ) : null}
      </Space>
      {showApprovalActions && hasNextApproverChoices && !isFinalApproval ? (
        <Space direction='horizontal' align='center'>
          <InputLabel htmlFor='next-approver-select' required>
            {intl.formatMessage(messages.nextApproverLabel)}
          </InputLabel>
          <Space.Item width={260}>
            <Select
              inputId='next-approver-select'
              options={nextApproverOptions}
              value={selectedNextApproverOption}
              onChange={(option) =>
                onSelectedNextApproverIdChange(option ? option.value : null)
              }
              placeholder={intl.formatMessage(messages.nextApproverPlaceholder)}
            />
          </Space.Item>
        </Space>
      ) : null}
    </Space>
  )
}

HeaderActions.displayName = 'HeaderActions'
